// main.js
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/index.scss'
import './directives/permission'
import drag from '@/directives/drag'
import axios from 'axios'  // 添加这行

Vue.directive('drag', drag)

Vue.config.productionTip = false
Vue.use(ElementUI)

// ========== 添加axios拦截器，打印请求和响应 ==========
// 请求拦截器
axios.interceptors.request.use(config => {

  return config
})

// 响应拦截器
axios.interceptors.response.use(
    response => {

      return response
    },
    error => {

      return Promise.reject(error)
    }
)
// ========== 拦截器添加结束 ==========

Vue.mixin({
  computed: {
    pageTitle() {
      const menus = this.$store.state.user?.menus || []
      const currentPath = this.$route.path
      const findMenuName = (list, path) => {
        for (let item of list) {
          if (item.path === path) return item.name
          if (item.children) {
            const found = findMenuName(item.children, path)
            if (found) return found
          }
        }
        return null
      }
      return findMenuName(menus, currentPath) || '项目管理'
    }
  }
})

function isTokenValid() {
  const token = localStorage.getItem('ShareWin-Token') || store.getters.token
  if (!token) return false
  return true
}

async function initApp() {
  const token = localStorage.getItem('ShareWin-Token') || store.getters.token

  if (token && isTokenValid()) {
    try {
      await store.dispatch('user/getUserInfo')
    } catch (error) {
      console.error('获取用户信息失败:', error)
      localStorage.removeItem('ShareWin-Token')
      localStorage.removeItem('ShareWin-Token-Time')
      localStorage.removeItem('ShareWin-User')
      store.dispatch('user/logout')
      if (window.location.pathname !== '/login') {
        router.push('/login')
      }
    }
  }

  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}

Vue.directive('show-start', {
  inserted(el) {
    const input = el.querySelector('.el-input__inner')
    if (input) {
      input.style.direction = 'ltr'
      input.style.textAlign = 'left'
      input.style.unicodeBidi = 'bidi-override'
    }
  }
})

initApp()